



























import { Component, Vue, Mixins, Watch, Prop } from 'vue-property-decorator'
import aiiTaskDetail from '@/views/AiiTasks/TasksDetail.vue'
import HomeInvestigateDetail from '@/views/homeInvestigate/HomeInvestigateDetail.vue'
import mediateTaskDetail from '@/views/mediate/taskDetail.vue'
import lawsuitTaskDetail from '@/views/lawsuit/taskDetail.vue'
import otherInvestigate from '@/views/other/taskDetail.vue'

@Component({
	components: {
		aiiTaskDetail,
		HomeInvestigateDetail,
		mediateTaskDetail,
		lawsuitTaskDetail,
		otherInvestigate,
	},
})
export default class TaskDetailTemplate extends Vue {
	@Prop()
	private task!: any
}
